export default __webpack_public_path__ + "static/media/warning--vehicles-and-others--g1.5639870f.png";